import Image from "@Components/Image";
import CustomLink from "@Components/CustomLink";
import config from "@Config/index";
import AndroidDownloadBadge from "@Icons/AndroidDownloadBadge";
import {
  APP_DOWNLOAD_APP_STORE_IMG,
  APP_DOWNLOAD_APP_STORE_LINK,
  APP_DOWNLOAD_PLAY_STORE_IMG,
  APP_DOWNLOAD_PLAY_STORE_LINK,
  APP_DOWNLOAD_QR_NAVBAR,
  CHINA_ANDROID_DOWNLOAD_LINK,
  PAGE,
} from "constants/configConstants";
import useTranslationHook from "hooks/useTranslationHook";
import styles from "./DownloadApp.module.scss";

const CHINA_QR_CODE_SRC =
  "https://prod-static-assets.amberstudent.com/images/china-app-download-QR.png";

const DownloadApp = ({ parentPage = PAGE.HOME }: { parentPage: string }) => {
  const { t } = useTranslationHook();
  const isChina = config.IS_CHINA_APP;
  const appDownloadQR = isChina
    ? CHINA_QR_CODE_SRC
    : APP_DOWNLOAD_QR_NAVBAR[parentPage || PAGE.HOME];

  const data = [
    {
      icon: "verified",
      boldText: "100%",
      text: t("header.downloadapp.verified_listings"),
    },
    {
      icon: "easy-booking",
      boldText: t("header.downloadapp.quick_and_easy"),
      text: t("header.downloadapp.bookings"),
    },
    {
      icon: "tagGreen",
      boldText: t("header.downloadapp.price_match"),
      text: t("header.downloadapp.guarantee"),
    },
    {
      icon: "message-smile",
      boldText: "24x7",
      text: t("header.downloadapp.personal_assistance"),
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.headingSection}>
        <h3>{t("header.downloadapp.title")}</h3>
        <p className={styles.details}>{t("header.downloadapp.subtitle")}</p>
      </div>
      <div className={styles.contentSection}>
        <div className={styles.QRWrap}>
          <p className={styles.qr}>{t("header.downloadapp.scan_qr")}</p>
          <Image
            className={styles.qrImg}
            src={appDownloadQR}
            alt="app QR"
            height={180}
            width={180}
            noTransformAnimation
          />
          <p>{t("header.downloadapp.download_from")}</p>
          <div className={styles.appLinks}>
            <CustomLink
              target="_blank"
              rel="noreferrer"
              href={isChina ? CHINA_ANDROID_DOWNLOAD_LINK : APP_DOWNLOAD_PLAY_STORE_LINK}
            >
              {isChina ? (
                <AndroidDownloadBadge width={131} height={39} />
              ) : (
                <Image
                  src={APP_DOWNLOAD_PLAY_STORE_IMG}
                  alt="play store"
                  width={131}
                  height={39}
                  noTransformAnimation
                />
              )}
            </CustomLink>
            <CustomLink target="_blank" rel="noreferrer" href={APP_DOWNLOAD_APP_STORE_LINK}>
              <Image
                src={APP_DOWNLOAD_APP_STORE_IMG}
                alt="app store"
                width={131}
                height={39}
                noTransformAnimation
              />
            </CustomLink>
          </div>
        </div>
        <div className={styles.uspWrap}>
          {data.map((it) => (
            <div className={styles.uspItem} key={it.icon}>
              <Image
                src={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/${it.icon}.svg`}
                alt={it.icon}
                width={20}
                height={20}
                noTransformAnimation
              />
              <p>
                <b>{it.boldText}</b> {it.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default DownloadApp;
